var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"NumberItem"},[_c('div',{staticClass:"value"},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('div',{staticClass:"description"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }